import { Pipe, PipeTransform } from '@angular/core';
import { Entry_type } from '../models/entry_type';

@Pipe({
  standalone: false,
  name: 'entryTypeHasHorse'
})
export class EntryTypeHasHorsePipe implements PipeTransform {

  transform(entryTypes: Entry_type[]): any {

     return entryTypes.filter(entry_type => (entry_type.enter_wo_horse == false && entry_type.barn_account == false));

  }

}
